import { Flex } from 'antd';
import {
  useAppSelector,
  useRequestTypeFinderById,
  useStatusFinderByNum,
} from '@Hooks/index';
import { useGetHrmRequestFormQuery } from '@Store/api/basicHrmApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { Status } from '@Components/Base';
import { getResumptionWorkShiftDict } from '@Store/selectors/dictionarySelector';
import fieldSource from './FieldSource';

import styles from './view-form.module.css';
import { getLabel } from '../../utils/resumingFrom';

const RequestViewForm: React.FC = () => {
  const { findRequestType: findLeaveRequestType } =
    useRequestTypeFinderById('Leave');
  const { findStatus } = useStatusFinderByNum('Resumption');
  const requestId = useAppSelector(getModalRecordKey);
  const { data } = useGetHrmRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });
  const { data: leaveReqData } = useGetHrmRequestFormQuery(
    String(data?.leaveTypeID),
    {
      skip: !data?.leaveTypeID,
      refetchOnMountOrArgChange: true,
    }
  );
  const resumptionWorkShifts = useAppSelector(getResumptionWorkShiftDict);

  if (!data) return null;

  const resumingFromLabel = getLabel(
    leaveReqData,
    findLeaveRequestType,
    'DD/MM/YYYY'
  );

  const findWorkShiftLabel = (workShift: number): string =>
    resumptionWorkShifts.find((shift) => shift.codeNum === workShift)
      ?.codeDesc || '';

  return (
    <Flex className={styles.viewForm} vertical>
      {fieldSource(data, resumingFromLabel, findWorkShiftLabel).map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          {item.label === 'Status' ? (
            <Status
              className={styles.viewItemValue}
              text={findStatus(Number(item.value))?.codeDesc || ''}
            />
          ) : (
            <span className={styles.viewItemValue}>{item.value}</span>
          )}
        </div>
      ))}
    </Flex>
  );
};

export default RequestViewForm;
